import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// MatFormFieldModule y MatInputModule no se usan al reemplazar por input simple
import { MatButtonModule } from '@angular/material/button';
import { OrderService } from '../../services/orders/order.service';
import { NgxToastrService } from '../../_services/ngx-toastr/ngx-toastr.service';

@Component({
  selector: 'app-client-name-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, FormsModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>Nombre del cliente</h2>
    <div mat-dialog-content>
      <input
        class="customer-input"
        [(ngModel)]="name"
        placeholder="Ingrese el nombre"
        type="text"
      />
    </div>
    <div mat-dialog-content *ngIf="isAdmin">
      <div class="mb-1" style="font-size: 12px; color: #666;">Fecha de creación (solo admin)</div>
      <input type="date" [(ngModel)]="createdLocal" (ngModelChange)="onDateChange($event)" class="customer-input" [disabled]="isUpdatingDate" />
      <div *ngIf="dateError" style="color:#dc2626; font-size:12px; margin-top:6px;">{{dateError}}</div>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-stroked-button (click)="onCancel()">Cancelar</button>
      <button mat-flat-button color="primary" (click)="onAccept()">Aceptar</button>
    </div>
  `,
  styles: [
    `
    .customer-input{width:100%; padding:10px 12px; border:1px solid #e2e8f0; border-radius:8px; outline:none; font-size:14px;}
    .customer-input:focus{border-color:#94a3b8; box-shadow:0 0 0 3px rgba(148,163,184,0.15)}
    `
  ]
})
export class ClientNameDialogComponent {
  name: string = '';
  isAdmin = false;
  createdLocal: string | undefined;
  isUpdatingDate = false;
  dateError: string | undefined;
  constructor(
    private dialogRef: MatDialogRef<ClientNameDialogComponent, { name: string; createdAt?: Date } | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: { name: string; isAdmin?: boolean; createdAt?: string | number | Date; orderUuid?: string },
    private orderService: OrderService,
    private toast: NgxToastrService,
  ) {
    this.name = this.normalizeName(data?.name);
    this.isAdmin = !!data?.isAdmin;
    const created = data?.createdAt ? new Date(data.createdAt) : undefined;
    this.createdLocal = created ? this.toLocalDateValue(created) : undefined;
  }

  onCancel() {
    this.dialogRef.close(undefined);
  }

  onAccept() {
    const val = this.normalizeName(this.name);
    // Al guardar, solo devolvemos el nombre. La fecha ya se invocó al cambiar calendario.
    this.dialogRef.close({ name: val });
  }

  private normalizeName(raw: any): string {
    // Evitar "[object Object]": sólo convertir a string cuando es primitivo; para objetos, extraer campos comunes
    if (typeof raw === 'string') return raw.trim();
    if (raw && typeof raw === 'object') {
      const candidates = [raw.name, raw.firstName, raw.lastName, raw.customerName, raw.fullName, raw.displayName];
      const found = candidates.find(v => typeof v === 'string' && v.trim().length > 0);
      return found ? found.trim() : '';
    }
    if (raw == null) return '';
    return String(raw).trim();
  }

  private toLocalDateValue(date: Date): string {
    const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
    const yyyy = date.getFullYear();
    const mm = pad(date.getMonth() + 1);
    const dd = pad(date.getDate());
    return `${yyyy}-${mm}-${dd}`;
  }

  // Invocar endpoint cuando cambia el calendario (solo admin)
  onDateChange(val: string) {
    if (!this.isAdmin) return;
    if (!val || typeof val !== 'string') return;
    if (!this.data?.orderUuid) {
      this.dateError = 'No hay identificador de la orden';
      return;
    }
    this.isUpdatingDate = true;
    this.dateError = undefined;
    try {
      this.orderService.setOrderCreatedAt(this.data.orderUuid, val).toPromise()
        .then(() => {
          // Éxito: mantenemos createdLocal en el input; backend persiste la fecha
          try { this.toast.success('Fecha de creación actualizada', 'toast-top-right'); } catch {}
        })
        .catch((e) => {
          console.error('Error actualizando fecha de creación', e);
          this.dateError = 'No se pudo actualizar la fecha';
          try { this.toast.error('No se pudo actualizar la fecha', 'toast-top-right'); } catch {}
        })
        .finally(() => {
          this.isUpdatingDate = false;
        });
    } catch (e) {
      console.error('Fecha inválida', e);
      this.dateError = 'Fecha inválida';
      this.isUpdatingDate = false;
    }
  }
}
